import { css, type Theme } from "@emotion/react";

export const modalContainer = css`
  padding: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: unset;
`;

export const modalContent = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0;
  position: relative;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 2rem;
  }
`;

export const iconSection = (theme: Theme) => css`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0.5rem;
  position: relative;
  background: ${theme.primary.backgroundMuted};
  width: 100%;
  height: 250px;

  @media (min-width: 768px) {
    min-width: 200px;
    width: auto;
    height: auto;
  }
`;

export const contentSection = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem;

  @media (min-width: 768px) {
    padding: 24px 24px 24px 0;
  }
`;

export const textSection = css`
  display: flex;
  flex-direction: column;
  gap: 0rem;
`;

export const formSection = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const buttonContainer = css`
  display: flex;
  justify-content: flex-end;
`;
